import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import {message} from './utils/resetMessage';
import App from './App.vue'


Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.prototype.$message = message;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
